import { LinksFTNode } from "../typings";

export class LinkDialogContext {
  dialogHeading: string;
  modules: LinksFTNode[];

  constructor(dialogHeading: string, modules: LinksFTNode[]) {
    this.dialogHeading = dialogHeading;
    this.modules = modules;
  }
}

export const LinksDialogContext = new LinkDialogContext("", []);
